"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.interruption.hint': 'Możesz przerwać agentowi mówiąc',
    'conversation.interruption.active': 'Przerywanie agenta...',
};
